import { useContext, useState } from 'react'
import { GameContext } from '../context/GameContext'
import FormingWordLettersRecipient from './FormingWordLettersRecipient'
import GuessedWordsRecipient from './GuessedWordsRecipient'
import MatchLettersRecipient from './MatchLettersRecipient'
import StatsChart from './StatsChart'
import SubmitButton from './SubmitButton'
import logo from './nithubLogo.svg'
import ShowAll from './ShowAll'

export default function GameApp () {
  const {
    setMatch,
    percentCompleted,
    clueCounter,
    clueWord,
    handleClickClueBtn,
    displayMatchWords,
    guessedWords
  } = useContext(GameContext)

  const [revealHelp, setRevealHelp] = useState(false)
  return (
    <>
      <main className='flex flex-col pb-3'>
        <header className='animate__bounceIn flex flex-col items-center w-full pb-6 text-white'>
          <img src={logo} alt='logo' className='w-20' />
          <h2 className='text-2xl font-bold'>Guess the Words</h2>
        </header>

        {percentCompleted === 100 ? (
          <>
            <menu className='animate__bounceIn mb-3 self-center'>
              <button
                onClick={setMatch}
                className='p-2 bg-green-500 text-white rounded'
              >
                <i className='bi bi-plus' />
                Play new match
              </button>
            </menu>
            <StatsChart />
          </>
        ) : (
          <>
            <section className='statsSection animate__bounceIn flex flex-col'>
              <p className='text-white'>{percentCompleted}% completed</p>
              <menu className='flex flex-col mt-2 '>
                <p className='remainingClues text-white'>
                  Remaining clues: {clueCounter}/3
                </p>
                <div className='flex justify-between'>
                  <div className='flex mt-2'>
                    <button
                      onClick={handleClickClueBtn}
                      className='w-28 p-2 text-white bg-[#4ba02d] rounded'
                    >
                      <i className='bi bi-search' /> Get clue
                    </button>
                    {clueWord ? (
                      <p className='animate__bounceIn ml-3 p-2 rounded bg-white text-center'>
                        <i className='bi bi-chat-text' /> {clueWord}
                      </p>
                    ) : (
                      ''
                    )}
                  </div>
                  {displayMatchWords && (
                    <div className='flex mt-2'>
                      <button
                        onClick={setMatch}
                        className='w-28 p-2 text-white bg-[#4ba02d] rounded'
                      >
                        Reset Game
                      </button>
                    </div>
                  )}
                </div>
              </menu>
            </section>

            <section className='gameplaySection flex justify-between'>
              <section className='sectionA flex flex-col mr-6'>
                <GuessedWordsRecipient />
              </section>

              <section className='sectionB flex flex-col justify-around'>
                {!displayMatchWords ? (
                  <>
                    <FormingWordLettersRecipient />
                    <MatchLettersRecipient />
                    <SubmitButton />
                    <ShowAll />
                  </>
                ) : (
                  <>
                    <h1 className='mt-2 mb-1 font-bold text-white'>
                      All words:
                    </h1>

                    <aside className='guessedWordsRecipient animate__bounceIn flex flex-col bg-white'>
                      {displayMatchWords?.map((word, index) => {
                        return (
                          <figure
                            key={index}
                            className={`guessedWord m-2 p-1 ${
                              guessedWords.includes(word)
                                ? 'bg-[#62cf3a]'
                                : 'bg-slate-300'
                            }`}
                          >
                            <span>{word}</span>
                          </figure>
                        )
                      })}
                    </aside>
                  </>
                )}
              </section>
            </section>

            <section
              className={`howToSection flex flex-col mt-6 bg-white p-2 rounded transition ease-in-out`}
              style={{ maxWidth: '500px' }}
            >
              <div className='flex justify-between items-center'>
                <h1 className='text-xl font-bold text-[#62cf3a]'>
                  How to play:{' '}
                </h1>
                <i
                  title='Click to reveal'
                  onClick={() => setRevealHelp(!revealHelp)}
                  className={`bi bi-chevron-${
                    revealHelp ? 'up' : 'down'
                  } bg-[#90DD74] text-white rounded p-1 hover:cursor-pointer `}
                ></i>
              </div>

              {revealHelp ? (
                <div className='px-3 py-2 text-[#131313]'>
                  <hr className='my-2 ' />

                  <p>
                    The player is given six jumbled letters, and must arrange
                    the letters in the jumble to form as many words of three or
                    more letters as they can.
                  </p>
                  <h1 className='mt-3 text-xl font-bold text-[#62cf3a]'>
                    Rules:
                  </h1>

                  <h2 className='font-bold text-[#62cf3a]'>
                    The game will accept:
                  </h2>
                  <ul className='list-disc ml-3'>
                    <li>Plural versions of already used words</li>
                  </ul>

                  <h2 className='font-bold mt-3 text-[#62cf3a]'>
                    The game will not accept:
                  </h2>
                  <ul className='list-disc ml-3'>
                    <li>Profanity</li>
                    <li>Words with less than three letters</li>
                  </ul>
                </div>
              ) : (
                ''
              )}
            </section>
          </>
        )}
      </main>
    </>
  )
}
